// extracted by css-extract-rspack-plugin
export default {"cls1":"TruncateHeight-cls1_qHt","cls2":"TruncateHeight-cls2_Ex2 TruncateHeight-cls1_qHt"};